import { createReducer } from 'typesafe-actions';
import { fetchIdsFlyoutDataAction, IDSFlyoutActionType } from './actions';
import { FlyoutContent, IDSFlyoutApiData, IDSFlyoutState } from './types';
import { get, typedObjectEntries } from 'Common/utils/objectUtils';

export const defaultIdsFlyoutState: IDSFlyoutState = {
    isFetching: false,
    isFetched: false,
    hasFailed: false,
    didInvalidate: false,
    error: undefined,
    identifier: '',
    flyoutItems: [],
};

export default createReducer<IDSFlyoutState, IDSFlyoutActionType>(defaultIdsFlyoutState)
    .handleAction(fetchIdsFlyoutDataAction.request, (state, action) => ({
        ...state,
        isFetching: true,
        identifier: action.payload.identifier,
    }))
    .handleAction(fetchIdsFlyoutDataAction.success, (state, action) => {
        const { data } = action.payload;
        const apiData = get(data, 'data.0', {}) as IDSFlyoutApiData;
        const flyoutItems = typedObjectEntries(apiData).reduce<FlyoutContent[]>((finalFlyoutItems, [key, value]) => {
            if (key?.startsWith('flyout') && value != null && typeof value !== 'string') {
                return finalFlyoutItems.concat({ ...value });
            }
            return finalFlyoutItems;
        }, []);
        return {
            ...state,
            isFetching: false,
            isFetched: true,
            hasFailed: false,
            didInvalidate: false,
            error: undefined,
            flyoutItems,
        };
    })
    .handleAction(fetchIdsFlyoutDataAction.failure, (state, action) => ({
        ...state,
        isFetching: false,
        isFetched: true,
        hasFailed: true,
        error: action.payload.error,
        didInvalidate: true,
    }));
